import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withFieldGroup } from '../hooks/use-app-form.js';
import { ClientSection } from './client-section.js';
import { ContactSection } from './contact-section.js';
import { FlightFields } from './flight-fields.js';
import { EstimatePassengersSection } from './passengers-section.js';
import { TourismFields } from './tourism-fields.js';
export const EstimateFormGroup = withFieldGroup({
    defaultValues: {},
    props: {},
    render: function Render({ clientPassengers, group, mode, onClientSelected, onIAmTraveler, readOnlyClient = false, selectedClient, withContactAutocomplete = false, }) {
        return (_jsxs("div", { className: "flex flex-col gap-6", children: [withContactAutocomplete ? (_jsx(ClientSection, { fields: {
                        clientFirstName: 'clientFirstName',
                        clientLastName: 'clientLastName',
                        contactEmail: 'contactEmail',
                        contactPhoneNumber: 'contactPhoneNumber',
                    }, mode: mode, form: group, onClientSelected: onClientSelected, selectedClient: selectedClient })) : readOnlyClient ? (_jsx(ClientSection, { fields: {
                        clientFirstName: 'clientFirstName',
                        clientLastName: 'clientLastName',
                        contactEmail: 'contactEmail',
                        contactPhoneNumber: 'contactPhoneNumber',
                    }, mode: "edit", form: group })) : (_jsx(ContactSection, { fields: {
                        clientFirstName: 'clientFirstName',
                        clientLastName: 'clientLastName',
                        contactEmail: 'contactEmail',
                        contactPhoneNumber: 'contactPhoneNumber',
                    }, form: group })), _jsx(EstimatePassengersSection, { fields: {
                        existingPassengerIds: 'existingPassengerIds',
                        newPassengers: 'newPassengers',
                    }, clientPassengers: clientPassengers, form: group, mode: mode, onIAmTraveler: onIAmTraveler, selectedClient: selectedClient }), _jsx(group.Subscribe, { selector: (state) => state.values.estimateType, children: (estimateType) => (_jsxs("section", { className: "space-y-4 rounded-lg border border-slate-200 bg-amber-50/50 p-4", children: [_jsx("h3", { className: "text-sm font-semibold tracking-wide text-amber-700 uppercase", children: "Voyage" }), estimateType === 'FLIGHT' ? (_jsx(FlightFields, { form: group, fields: {
                                    companyPreference: 'companyPreference',
                                    complementaryInformation: 'complementaryInformation',
                                    flights: 'flights',
                                    maxStayDuration: 'maxStayDuration',
                                    particularities: 'particularities',
                                    travelClass: 'travelClass',
                                    type: 'type',
                                } })) : (_jsx(TourismFields, { form: group, fields: {
                                    approximativeBudget: 'approximativeBudget',
                                    carLoan: 'carLoan',
                                    complementaryInformation: 'complementaryInformation',
                                    departure: 'departure',
                                    departureDate: 'departureDate',
                                    departureFlexibilityAfter: 'departureFlexibilityAfter',
                                    departureFlexibilityBefore: 'departureFlexibilityBefore',
                                    destination: 'destination',
                                    hotelMinimumNumberOfStars: 'hotelMinimumNumberOfStars',
                                    maxStayDuration: 'maxStayDuration',
                                    onSiteActivities: 'onSiteActivities',
                                    pension: 'pension',
                                    returnDate: 'returnDate',
                                    returnFlexibilityAfter: 'returnFlexibilityAfter',
                                    returnFlexibilityBefore: 'returnFlexibilityBefore',
                                    transfertFromAirport: 'transfertFromAirport',
                                    travelClass: 'travelClass',
                                    type: 'type',
                                } }))] })) })] }));
    },
});
